<template>
    <div>
        <div id="sending" v-if="state == 'fetching'">
            <div class="overlay"></div>
            <div class="form-sending"></div>
        </div>
        <modal
            name="gigs"
            :adaptive="true"
            :scrollable="true"
            :reset="true"
            width="90%"
            :maxWidth="1100"
            height="auto"
        >
            <div class="modal__content">
                <div class="modal__header container">
                    Keikat - {{ bandName }}
                </div>
                <div class="gigs-list container">
                    <h3>Tulevat ({{ upcoming.length }})</h3>
                    <div class="row gigs-list__row" v-for="gig in upcoming" :key="gig.id">
                        <div class="col-md-2 gigs-list__item">
                            {{ eventDate(gig.dateandtime.date) }}
                        </div>
                        <div class="col-md-5 gigs-list__item">
                            <span v-if="gig.venueName">{{ gig.venueName }}</span>
                            <span v-else>Yksityistilaisuus</span>
                        </div>
                        <div class="col-md-5 gigs-list__item">
                            {{ gig.city.cityName }}
                        </div>
                    </div>
                    <h3>Vedetyt ({{ passed.length }})</h3>
                    <div class="row gigs-list__row" v-for="gig in passed" :key="gig.id">
                        <div class="col-md-2 gigs-list__item">
                            {{ eventDate(gig.dateandtime.date) }}
                        </div>
                        <div class="col-md-5 gigs-list__item">
                            <span v-if="gig.venueName">{{ gig.venueName }}</span>
                            <span v-else>Yksityistilaisuus</span>
                        </div>
                        <div class="col-md-5 gigs-list__item">
                            {{ gig.city.cityName }}
                        </div>
                    </div>
                </div>
                <div class="modal__footer">
                    <span class="btn btn--hollow btn--small btn--call-to-action" @click="closeModal">Sulje</span>
                </div>
            </div>
        </modal>
        <div>
            <a class="btn--show-all-gigs" @click="openModal">Näytä kaikki keikat</a>
        </div>
    </div>
</template>

<script>
    import moment from 'moment';
    import ApiCall from '../modules/ApiCall';
    import Routes from '../modules/Routes';

    export default {
        props: {
            bandSlug: {
                type: String
            },
            bandName: {
                type: String
            }
        },
        data() {
            return {
                upcoming: [],
                passed: [],
                state: 'done'
            };
        },
        methods: {
            fetchGigs() {
                this.showLoading();
                return ApiCall.getCached(this.getUrl(), true).then((response) => {
                    this.passed = response.passed;
                    this.upcoming = response.upcoming;
                    this.hideLoading();
                });
            },
            getUrl() {
                return Routes.generate('_public_api_gigs', { bandSlug: this.bandSlug });
            },
            openModal() {
                this.fetchGigs().then(() => {
                    this.$modal.show('gigs');
                    this.$ga.event('Gigs', 'Show all gigs opened');
                    gtag('event', 'view_all_gigs');
                });
            },
            showLoading() {
                this.state = 'fetching';
            },
            hideLoading() {
                this.state = 'done';
            },
            closeModal() {
                this.$modal.hide('gigs');
                return false;
            },
            eventDate(d) {
                console.log('date', d);
                return moment(d).format('D.MM.YYYY');
            }
        },
    };
</script>
